import axiosHttp from "services/axiosHttp";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// Backend sets exactly one preferred unit for an item.
export const setPreferredUnit = createAsyncThunk(
	"unitDetails/setPreferredUnit",
	async ({ channelId, item_id, unit_id } = {}, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.post(`channel/${channelId}/unitDetails/set-preferred`, {
				item_id,
				unit_id,
			});
			return response.data?.data ?? response.data;
		} catch (err) {
			return rejectWithValue(err?.response?.data?.message || err?.response?.data || err?.message || "Failed to set preferred unit");
		}
	}
);

const SetPreferredUnitSlice = createSlice({
	name: "SetPreferredUnitSlice",
	initialState: {
		isLoading: false,
		error: null,
		data: null,
	},
	extraReducers: (builder) => {
		builder
			.addCase(setPreferredUnit.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(setPreferredUnit.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
			})
			.addCase(setPreferredUnit.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload || action.error?.message;
			});
	},
});

export default SetPreferredUnitSlice.reducer;

